import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Constant } from "../Shared/Constant";
import { ApiServiceService } from "./api-service.service";
import { BehaviorSubject, Observable, catchError, map, of, throwError } from "rxjs";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  SERVER_URL = environment.serverUrl;

  constructor(
    private http: HttpClient,
    private apiServeice: ApiServiceService,
    private router: Router
  ) {}

  public userSubject = new BehaviorSubject<any | null>(this.getUser());
  user$ = this.userSubject.asObservable();

  login(context: any, remember: boolean): Observable<any> {
    return this.apiServeice
      .loginPost_("/auth/login", JSON.stringify(context))
      .pipe(
        map((response: any) => {
          if (response.success == true) {
            localStorage.setItem("loginStatus", "SUCCESS");
          }
          return response;
        }),
        catchError((error) => {
          return throwError(() => (error));
        })
      );
  }

  setUser(user: any): void {
    const serialized = JSON.stringify(user);
    localStorage.setItem(Constant.USER_DATA, serialized);
    this.userSubject.next(serialized);
  }

  // logout() {
  //   localStorage.clear();
  //   sessionStorage.clear();
  //   location.href = this.router.createUrlTree(["/"]).toString();
  //   return this.apiServeice.logout("/logout").pipe(
  //     map((response: any) => {
  //       // if (response.success == true) {
  //       //   localStorage.setItem("loginStatus", "SUCCESS");
  //       // }
  //       location.href = this.router.createUrlTree(["/"]).toString();
  //       return response;
  //     }),
  //     catchError((error) => {
  //       return of(error);
  //     }),
  //   );
  // }

  public Register(url: any, Data: any) {}

  public getPasswordResetLink(email: any) {
    return this.apiServeice.loginPost_(
      "/auth/password-reset-link?email=" + email,
      {}
    );
  }

  get isLoggedIn(): boolean {
    return !!localStorage.getItem(Constant.USER_DATA);
  }

  getToken(): string | null {
    return localStorage.getItem(Constant.LOGGED_IN_USER);
  }

  getUser(): any | null {
    if (!this.isLoggedIn) return null;
    return JSON.parse(JSON.stringify(localStorage.getItem(Constant.USER_DATA)));
  }
  getUserId(): any | null {
    if (!this.isLoggedIn) return null;
    return JSON.parse(localStorage.getItem(Constant.USER_DATA)).userId;
  }

  getRoles() {
    return this.apiServeice.LoginGet("/auth/role/get");
  }

  getMdaRoles() {
    const deptId = this.getDept();

    return this.apiServeice.LoginGet("/auth/role/get/mda?deptId=" + deptId);
  }

  getPriviliage() {
    return JSON.parse(this.getUser())
      ?.roles?.priviliages?.split(",")
      .map(function (value: any) {
        return value.trim();
      });
  }

  getAccount() {
    return JSON.parse(this.getUser())?.account;
  }

  getTinNumber() {
    return JSON.parse(this.getUser())?.tin;
  }

  checkFirstLogin() {
    return JSON.parse(this.getUser())?.firstLogin;
  }

  getEmail() {
    return JSON.parse(this.getUser())?.email;
  }

  getDept() {
    return JSON.parse(this.getUser())?.deptId;
  }
  getDeptName() {
    return JSON.parse(this.getUser())?.department;
  }

  getDisplayName() {
    return JSON.parse(this.getUser())?.displayName;
  }

  getPhoneNumber() {
    return JSON.parse(this.getUser())?.phoneNumber;
  }

  getRole() {
    return JSON.parse(this.getUser())?.roles?.name;
  }

  getId() {
    return JSON.parse(this.getUser())?.userId;
  }
  getPrimaryColor() {
    return JSON.parse(this.getUser())?.mdaConfig?.primary_background_color;
  }

  getSecondaryColor() {
    return JSON.parse(this.getUser())?.mdaConfig?.secondary_background_color;
  }

  getPrimaryTextColor() {
    return JSON.parse(this.getUser())?.mdaConfig?.primary_text_color;
  }

  getSecondaryTextColor() {
    return JSON.parse(this.getUser())?.mdaConfig?.secondary_text_color;
  }
  getDescription() {
    return JSON.parse(this.getUser())?.mdaConfig?.description;
  }

  getLogo() {
    return JSON.parse(this.getUser())?.mdaConfig?.logo;
  }

  public hasRole(role: any) {
    return this.getPriviliage()?.includes(role);
  }

  public hasAnyPermission(permissions: string[]) {
    for (let permission of permissions) {
      if (this.hasRole(permission)) {
        return true;
      }
    }
    return false;
  }

  public forbidAccess() {
    this.router.navigate(["/auth/login"]);
  }

  logout(redirect: boolean = true): void {
    // Immediately clear user data and redirect
    localStorage.removeItem(Constant.USER_DATA);
    localStorage.removeItem(Constant.LOGGED_IN_USER);
    localStorage.removeItem(Constant.SESSION_TIMER);
    this.userSubject.next(null);

    if (redirect) {
      this.router.navigate(["/auth/login"]);
    }

    // Make the backend logout call asynchronously
    const url = "/auth/logout/user?email=" + this.getEmail();
    this.apiServeice.loginPost_(url, {}).subscribe(
      () => {
        console.log("User successfully logged out from backend.");
      },
      (error) => {
        console.error("Error logging out from backend:", error);
      }
    );
  }

  getTaxOffice() {
    return JSON.parse(this.getUser()).taxOfficeName;
  }

  getZone() {
    return JSON.parse(this.getUser()).zoneName;
  }
  getZoneId() {
    return JSON.parse(this.getUser()).zoneId;
  }
  getTaxofficeId() {
    return JSON.parse(this.getUser()).taxOfficeId;
  }
}
